// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1421":"a0e187c9","4918":"0b60df10"}[chunkId] || chunkId) + "." + {"117":"e5ab1a9c445804dc","353":"0abbb62496e6f617","1421":"6bbc4e06bb8662a3","1578":"16de11e651027770","4376":"3d0fb905c1f8081f","4918":"91b03d51ef8216f7","5853":"118b6eddeccf125b","8412":"9d5872dc12a28eb0"}[chunkId] + ".js";
};